<div
    [@slideInOut]="(filterDisplay$ | async) ? 'visible' : 'hidden'"
    class="advanced-filters-container">
    <div class="advanced-filters">
        <label class="filter-actions-title">Filter Actions</label>
        <div class="filter-actions">
            <div>
                <pf-button
                    buttonType="clear-square"
                    (click)="filterService.clearFilters()">
                    Clear
                </pf-button>
            </div>
            <pf-button
                buttonType="apply"
                [nz-tooltip]="
                    hasValidationIssues
                        ? 'Enter required information to apply changes.'
                        : ''
                "
                (click)="filterService.applyFilters()"
                [disabled]="!filterService.canApply">
                Apply
            </pf-button>
        </div>
        <pf-text-search-filter
            [filter]="{
                name: 'Search All',
                filterKey: 'search',
                filterType: 'text'
            }"
            (filterComponentReady)="filterComponentsReadyHandler('Search')"
            (filterChangeEmitter)="filterChangeHandler($event)"
            [filtersAreReady$]="filtersAreReady$">
        </pf-text-search-filter>
        @for (filter of filters$ | async; track filter.name) {
            @switch (filter.filterType) {
                @case ("text") {
                    <pf-text-search-filter
                        [filter]="{
                            name: filter.name,
                            filterKey: filter.filterKey,
                            filterType: filter.filterType,
                            tooltip: filter.tooltip
                        }"
                        (filterChangeEmitter)="filterChangeHandler($event)"
                        (filterComponentReady)="
                            filterComponentsReadyHandler(filter.filterKey)
                        "
                        [filtersAreReady$]="filtersAreReady$">
                        >
                    </pf-text-search-filter>
                }
                @case ("boolean") {
                    <pf-switch-filter
                        [filter]="filter"
                        [filtersAreReady$]="filtersAreReady$"
                        (filterChangeEmitter)="filterChangeHandler($event)"
                        (filterComponentReady)="
                            filterComponentsReadyHandler(filter.filterKey)
                        ">
                    </pf-switch-filter>
                }
                @case ("multi-select") {
                    <pf-checkbox-group-filter
                        pfStyle="stacked"
                        [filter]="filter"
                        [filtersAreReady$]="filtersAreReady$"
                        (filterChangeEmitter)="filterChangeHandler($event)"
                        (filterComponentReady)="
                            filterComponentsReadyHandler(filter.filterKey)
                        ">
                    </pf-checkbox-group-filter>
                }
                @case ("date") {
                    <pf-segmented-date-filter
                        [filter]="filter"
                        [filtersAreReady$]="filtersAreReady$"
                        (filterChangeEmitter)="filterChangeHandler($event)"
                        (filterComponentReady)="
                            filterComponentsReadyHandler(filter.filterKey)
                        ">
                    </pf-segmented-date-filter>
                }
            }
        } @empty {
            <div class="no-filters">No filters available</div>
        }
    </div>
</div>
